<template>
  <div class="breadcrumb">
    <router-link to="/home" class="bn-root">格力泰山</router-link>
    <div class="bn-item" v-for="(item, index) in guide" :key="index">
      <span class="bn-sep">&gt;</span>
      <span class="bn-label" :class="{ current: index === guide.length - 1 }">{{ item.label }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "breadcrumb2",
  props: {
    guide: {
      type: Array
    }
  }
}
</script>

<style scoped lang="less">
.breadcrumb {
  position: relative;
  width: 90%;
  margin: 0 auto;
  padding: 20px 0;
  font-size: 14px;
  color: #cacdd5;
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}

.bn-root {
  color: #cacdd5;
  transition: color 0.3s;
}

.bn-root:hover {
  color: #1f58ff;
}

.bn-item {
  display: flex;
  align-items: center;
  gap: 6px;
}

.bn-sep {
  color: #cacdd5;
  margin: 0 2px;
}

.bn-label {
  color: #cacdd5;
}

.bn-label.current {
  color: #F2F2F4;
  font-weight: 600;
}

@media only screen and (min-width: 1200px) {
  .breadcrumb {
    width: 1600px;
  }
}
</style>
